const AUDIO_TYPE_ALIASES = {
  ambient_sound: 'ambient_sound',
  ambience: 'ambient_sound',
  thinking_sound: 'thinking_sound',
  background_audio: 'thinking_sound',
};

function normalizeText(value) {
  const text = String(value || '').trim();
  return text || '';
}

function normalizeOptionalText(value) {
  const text = normalizeText(value);
  return text || undefined;
}

function normalizeBoolean(value) {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (['true', '1', 'yes', 'on'].includes(normalized)) return true;
    if (['false', '0', 'no', 'off'].includes(normalized)) return false;
  }
  if (typeof value === 'number') {
    return value !== 0;
  }
  return undefined;
}

export function normalizeBackgroundAudioType(value) {
  const normalized = normalizeText(value).toLowerCase();
  return AUDIO_TYPE_ALIASES[normalized] || '';
}

export function normalizeBackgroundAudioOption(option) {
  if (typeof option === 'string') {
    const name = normalizeText(option);
    return name ? { name, volume: 0.3 } : null;
  }

  if (!option || typeof option !== 'object') {
    return null;
  }

  const name = normalizeText(option.name);
  if (!name) {
    return null;
  }

  const normalized = {
    name,
    volume: Number.isFinite(Number(option.volume)) ? Number(option.volume) : 0.3,
  };

  const optionType = normalizeBackgroundAudioType(option.type);
  if (optionType) {
    normalized.type = optionType;
  }

  const active = normalizeBoolean(option.active);
  if (active !== undefined) {
    normalized.active = active;
  }

  for (const key of [
    'id',
    'background_url',
    'preview_url',
    'bucket_name',
    'file_key',
    'source_file_name',
    'content_type',
  ]) {
    const value = normalizeOptionalText(option[key]);
    if (value) {
      normalized[key] = value;
    }
  }

  return normalized;
}

export function normalizeBackgroundAudioSelections(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items
    .map((item) => normalizeBackgroundAudioOption(item))
    .filter(Boolean);
}

export function splitBackgroundAudioOptions(items) {
  const ambientSoundOptions = [];
  const thinkingSoundOptions = [];
  const seenKeys = new Set();

  normalizeBackgroundAudioSelections(items).forEach((item) => {
    const optionKey = String(item.id || item.file_key || `${item.type || 'unknown'}:${item.name}`).trim();
    if (!optionKey || seenKeys.has(optionKey)) {
      return;
    }
    seenKeys.add(optionKey);

    if (item.type === 'ambient_sound') {
      ambientSoundOptions.push(item);
      return;
    }
    if (item.type === 'thinking_sound') {
      thinkingSoundOptions.push(item);
    }
  });

  ambientSoundOptions.sort((left, right) => left.name.localeCompare(right.name));
  thinkingSoundOptions.sort((left, right) => left.name.localeCompare(right.name));

  return { ambientSoundOptions, thinkingSoundOptions };
}
